<template> 
<div class="result-top">
  <!-- <el-row :gutter="24">  -->
    <header class="header2">
      <el-form :inline="isInline" :model="formInline" class="search-form">
        <el-form-item>
          <a href="/"><img src="../assets/images/result-logo.png" width="58" height="60"></a>
        </el-form-item>
        <!-- <div class="search-form-bg"></div> -->
        <div class="search-form-bg">
          <div class="search-form-inline">
          <el-form-item label="年份" class="search-form-item">
              <!-- <div class="block"> -->
                <!-- <span class="demonstration">年份</span> -->
                <el-date-picker
                  v-model="year"
                  align="right"
                  type="year"
                  placeholder="选择年"
                  @change="dateChange">
                </el-date-picker>

                  <!-- :picker-options="pickerOptions0" -->
              <!-- </div> -->
            </el-form-item>
            <el-form-item label="所获奖项" class="search-form-item">
              <el-select v-model="awardId" placeholder="测评榜单"
                clearable
                :loading="loading" @visible-change="vchange(awardId)" @change="showList(awardId)" @clear="clearSelect">
                <el-option v-for="item in anameOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="" class="search-form-item">
              <!-- <el-cascader
                placeholder="子榜单"
                :options="subnameOptions"
                @change="getThisAwardsId"
                :props="props"
                clearable
                filterable
                change-on-select
                :disabled="subnameOptions.length == 0"
              ></el-cascader> -->
              <el-cascader placeholder="子榜单"
                  v-model="selectedOptions"
                  :options="subnameOptions"
                  @change = "getaaa"
                  :props="props"
                  :clearable="true"
                  change-on-select
                  :disabled="subnameOptions.length == 0">
                </el-cascader>  
            </el-form-item>
            <el-form-item label="企业名称" class="search-form-item">
              <el-input v-model="formInline.qname" placeholder="请输入企业名称" @keyup.enter.native="onSubmit"></el-input> 
            </el-form-item>
            <el-form-item class="search-form-item">
              <el-button class="search-form-button" @click="onSubmit">查询</el-button>
            </el-form-item>
            </div>
        </div>
      </el-form>
    </header>
    <el-button class="return-button" v-if="this.qname != ''" type="primary" @click="onSearch">返回上一步</el-button>
    <div class="result-list-out">
      <el-col :span="24"> 
        <!--  && (this.awardId != '' || this.awardSubId != '') -->
        <div v-if="this.formInline.qname != ''">
          
          <!-- 4显示企业所获奖项列表 -->
          您所查询的结果是:<h2>{{this.formInline.year}} {{getTopAwardsName(this.awardId, this.anameOptions)}}</h2>
          <h2>{{this.formInline.qname}}</h2>
          <el-table :data="tableData" class="result-list-table">
            <el-table-column type="index" width="80">
            </el-table-column>
            <el-table-column
              label="获奖情况" align="left">  
              <template scope="scope">
                <span>{{scope.row.qname}} 获</span>
                <span><b>{{scope.row.year}}</b>年</span>
                <span>
                  <!-- {{scope.row.award}} -->
                  <span v-if="scope.row.award != undefined && scope.row.award.preId != ''">{{getTopAwardsName(scope.row.award.preId,anameOptions)}}子榜单</span>
                    <a href="javascript:;" @click="gotoList(scope.row.awardId,scope.row.aname)" class="j1">{{scope.row.aname}}</a>
                </span>
                <span v-if="scope.row.awardsorder != undefined && scope.row.awardsorder != ''"><b>第{{scope.row.awardsorder}}名</b></span>
                <el-tag v-if="scope.row.lcode != undefined" type="primary" close-transition><i class="el-icon-my-shuju"></i>{{scope.row.lcode}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>

      <el-col :span="24"> 
        <!-- 2显示子栏目下的获奖企业列表 -->
        <div v-if="this.formInline.qname == '' && (this.awardId != '' || this.awardSubId != '')">
        您所查询的结果是:<h2>{{this.formInline.year}} <span v-if="this.awardsSubNames != undefined">{{getTopAwardsName(this.awardId, this.anameOptions)}}</span></h2>
        <h2>{{this.awardsNames}}</h2>
        <h2>{{this.awardsSubNames}}</h2>
          <el-table :data="tableData" border>
            <el-table-column prop="year" align="left" label="年份">
            </el-table-column>
            <el-table-column prop="awardsorder" align="left" label="排名" v-if="hasValue('awardsorder', tableData)">
              <template scope="scope">
                {{scope.row.awardsorder}}
              </template>
            </el-table-column>
            <el-table-column prop="qname" align="left" label="企业名称" v-if="this.awardId != 2"> 
              <template scope="scope">
                {{scope.row.qname}}
              </template>
            </el-table-column>
            <el-table-column prop="qname" align="left" label="企业名称" v-else-if="this.year < 2021">
                <template scope="scope">
                  {{scope.row.qname}}
                </template>
            </el-table-column>
            <el-table-column prop="lname" align="left" label="证券简称" v-if="hasValue('lname', tableData)">
              <template scope="scope">
                {{scope.row.lname}}
              </template>
            </el-table-column>
            <el-table-column prop="lcode" align="left" label="证券代码" v-if="hasValue('lcode', tableData)">
              <template scope="scope">
                {{scope.row.lcode}}
              </template>
            </el-table-column>
            <el-table-column prop="projectname" align="left" label="项目名称" v-if="hasValue('projectname', tableData)">
              <template scope="scope">
                {{scope.row.projectname}}
              </template>
            </el-table-column>
            <el-table-column prop="brandname" align="left" label="品牌名称" v-if="hasValue('brandname', tableData)">
              <template scope="scope">
                {{scope.row.brandname}}
              </template>
            </el-table-column>
            <el-table-column prop="firstbrandrate" align="left" label="首选品牌率" v-if="hasValue('firstbrandrate', tableData)">
              <template scope="scope">
                {{scope.row.firstbrandrate}}
              </template>
            </el-table-column>
            <el-table-column prop="brandvalue" align="left" label="品牌价值（亿元)" v-if="hasValue('brandvalue', tableData)">
              <template scope="scope">
                {{scope.row.brandvalue}}
              </template>
            </el-table-column>
            <el-table-column prop="awardsname" align="left" label="奖项名称" v-if="hasValue('awardsname', tableData)">
              <template scope="scope">
                {{scope.row.awardsname}}
              </template>
            </el-table-column>
            <el-table-column prop="subindustry" align="left" label="子产业" v-if="hasValue('subindustry', tableData)">
              <template scope="scope">
                {{scope.row.subindustry}}
              </template>
            </el-table-column>
            <el-table-column prop="professionalfield" align="left" label="专业领域/行业领域" v-if="hasValue('professionalfield', tableData)">
              <template scope="scope">
                {{scope.row.professionalfield}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>

      <el-col :span="24" v-if="this.formInline.qname == '' && this.formInline.year == '' && this.awardId == '' && this.awardSubId == ''">
      暂时没有内容
      </el-col>
      <!--  v-if="this.awardSubId != ''" -->
      <el-col :span="24" v-if="this.formInline.qname != '' || this.formInline.year != '' || this.awardId != '' || this.awardSubId != ''">
        <el-pagination
            small
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[25, 50, 100, 200]"
            :page-size="countPerPage"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
      </el-col> 

    </div>
    <div class="join-us">
      <a href="http://www.fangchan.com/zt/cp/index.html" target="_blank"><img src="../assets/images/join-us.png" width="125" height="60" /></a>
    </div>

  <!-- </el-row> -->
</div>  
</template>
<script>
function getData(thisObj, queryObj, countPerPage, currentPage, idArr){
  var paramsObj = {   
        params : {
              where: queryObj, 
              countPerPage: countPerPage, 
              currentPage: currentPage,
              idArr: (queryObj.qname == '') ? thisObj.awardSubId : idArr
        }
      };
  thisObj.$http.get('api/search/getcompany', paramsObj).then(
    response => {
        thisObj.tableData = response.body.listArr;
        thisObj.total = response.body.count;
      },
    response => {
        console.log('failed');
    }
  );
};
function getOptionsKey(value, arrObj){
  var key = 0;
  for(var v in arrObj){
    if(arrObj[v].value == value){
      key = v;
    }
  }
  return key;
};
function getAwardsName(id,thisObj){
  if(id.length > 0){
    thisObj.$http.get('api/search/awards_list', {params: {id: id}}).then(
        response => {
          var awardsList = response.body;
          thisObj.awardsNames = '';
          for(var v in awardsList){
            thisObj.awardsNames += ' ' + awardsList[v].name;
          }
        },
        response => {
          console.log('failed');
        }
      )
  }else{
    thisObj.awardsNames = '';
  }
  
}
function getAwardsIdArr(thisObj, id){
}

function _mapOptions(_id, _thisSubOption, _thisObj){
  _thisObj.$http.get('api/search/get_awards_sublist',{params: {preId: _id}}).then(
    response => {
      var k = getOptionsKey(_id, _thisSubOption.children); //此级分类在当前数组中的位置
      var nextSubOption = _thisSubOption.children[k];
      nextSubOption.children = response.body.map(item=>{
        return {label:item.name, value:item.id, children:null};
      });
    }
  )
}

function _subOptionsConfig(_preId, _subnameOptions, _thisObj){
      var that = _thisObj;
      var k = getOptionsKey(_preId, _subnameOptions);
      var thisSubOption = _subnameOptions[k];
      _thisObj.$http.get('api/search/get_awards_sublist',{params: {preId: _preId}}).then(
        response =>{
          var sublist = response.body;
          var tmparr = [];
          sublist.forEach(function(element){
            var tmpopt = {label:element.name, value:element.id,children:null};
            tmparr.push(tmpopt);
            thisSubOption.children = tmparr;
            var k = getOptionsKey(element.id, thisSubOption); //此级分类在当前数组中的位置
            var nextSubOption = thisSubOption.children[k];
            if(element.issub){
              _mapOptions(element.id, nextSubOption, _thisObj);
            }
          },this);
        },
        response => {
          console.log('failed');
        }
      )
};
export default {
  name: 'result',
  data () {
   return {
      msg: '',
      tableData: [],  //按企业搜索结果
      anameOptions: [],  //一级奖项列表
      selectedOptions:[],
      subnameOptions: [],  //二级奖项列表
      qnameList:[],   //企业名称列表
      awardId: '',
      awardSubId: '',
      awardsSubNames: '',
      awardsNames: '',
      loading: false,
      total:0,
      countPerPage: 25,
      currentPage: 1,
      year:'',
      pickerOptions0:{
        disabledDate(time) {
          var date = new Date(2019,0,1);
          return time.getTime() > date-8.64e7;
        }
      },
      formInline: {
        // awardId: '',
        qname: '',
        year: ''
      },
      idArr:[],
      firstIdArr:[],
      props: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      qname: '',
      isInline: true
    }
  },
  mounted: function(){
    var that = this;
    that.setHeight();
    $(window).resize(function(){
      that.setHeight();
    });
      this.$nextTick(function () {
          this.$http.get('/api/search/awards_list',{params: {id: 1}}).then( //修改于2021.06.18 只显示500强的数据
            response => {
              var anameArr = response.body;
              for(var v in anameArr){
                if(anameArr[v].preId == 0){
                  var o = {value: anameArr[v].id, label: anameArr[v].name}
                  this.anameOptions.push(o);
                }
              }
            },
            response => {
              console.log('failed');
            }
          );
          var query = this.$route.query;
          this.formInline.qname = this.$route.query.qname;
          this.year = (query.year == undefined)? '': query.year;
          for(var v in query){
            this.formInline[v] = query[v];
            if(v == 'awardId'){
              this.awardId = (query.awardId=='')? '' : parseInt(query.awardId);
              this.idArr.push(query.awardId);
            }
          }
          var paramsObj = {
            params : {
              where : this.$route.query,
              countPerPage: this.countPerPage, 
              currentPage: this.currentPage,
              idArr: this.idArr
            }
          };
          // getData(this, this.formInline, countPerPage, currentPage, idArr);
          this.$http.get('api/search/getcompany', paramsObj).then(
            response => {
                this.tableData = response.body.listArr;
                this.total = response.body.count;
              },
            response => {
              console.log('failed');
            }
          );
        });
  },
  watch: {
    year: {
        handler:function(val,oldval){
            if(val != oldval){
              var year = (val==undefined) ? new Date() : new Date(val);
              this.year = (val==undefined) ? '' : val.toString();
              this.formInline.year = year.getFullYear();
            }
        },
        deep:true//对象内部的属性监听，也叫深度监听
    },
    formInline: {
      handler: function(val,oldval){
        this.$router.push({path: 'result', query: this.formInline});
        getData(this, val, this.countPerPage, this.currentPage, this.idArr);
      },
      deep: true
    },
    idArr: {
      handler: function(val,oldval){
        // if(this.formInline.year != ''){
          this.$router.push({path: 'result', query: this.formInline});
          getData(this, this.formInline, this.countPerPage, this.currentPage, val);
        // }
      },
      deep: true
    }
  },
  methods: {
    showList (awardId) {  //一级奖项下拉框change方法
      this.idArr = [];
      this.awardSubId = '';
      this.awardId = '';
      this.awardsNames = '';
      this.awardsSubNames = '';
      this.subnameOptions = [];
      if(awardId == ''){
        this.subnameOptions.length = 0;
        this.formInline.awardId = '';
      }else{
        this.awardSubId = this.awardId = awardId;
        this.idArr.push(awardId);
        this.$http.get('api/search/get_awards_sublist', {params: {preId: awardId, year: this.year}}).then(  //获取下一级奖项   这部分有待二次开发
          response => {
            var sublist = response.body;
            for(var v in sublist){
              if(sublist[v].issub == 0){
                this.idArr.push(sublist[v].id);
              }else{
                this.idArr.push(sublist[v].id);
                this.$http.get('api/search/get_awards_sublist', {params: {preId: sublist[v].id}}).then( //获取下一级奖项
                  response => {
                    var sublist1 = response.body;
                    for(var v in sublist1){
                      this.idArr.push(sublist1[v].id);
                    }
                    this.firstIdArr = this.idArr;
                  }
                )
              }
              
            }
            this.subnameOptions = sublist.map(item => {
              if(item.issub == 0){
                return {label: item.name, value: item.id};
              }else{
                return {label: item.name, value: item.id, children:[]};
              }
              
            });
          },
          response => {
            console.log('failed');
          }
        )
      }
    },
    vchange (awardId){
      console.log('暂时用不上了此事件');
    },
    dateChange(val){
      if(val == undefined){
        // if(this.formInline.qname == ''){
        //   this.$alert('日期错误','注意：',{
        //   confirmButtonText: '确定',
        //   type: 'warning'
        //   }).then(() => {
        //     for(var k in this.formInline){
        //       this.formInline[k] = '';
        //     }
        //     var year = new Date();
        //     this.formInline.year = year.getFullYear();
        //     this.year = this.formInline.year.toString();
        //   });
        // }else{
          this.year = '';
          this.formInline.year = '';
        // }
      }else{
        this.year = val; 
        this.formInline.year = val;
        if(this.awardId != undefined && this.awardId != ''){
          this.$http.get('api/search/get_awards_sublist', {params: {preId: this.awardId, year: this.year}}).then(  //获取下一级奖项   这部分有待二次开发
          response => {
              var sublist = response.body;
              for(var v in sublist){
                if(sublist[v].issub == 0){
                  this.idArr.push(sublist[v].id);
                }else{
                  this.idArr.push(sublist[v].id);
                  this.$http.get('api/search/get_awards_sublist', {params: {preId: sublist[v].id}}).then( //获取下一级奖项
                    response => {
                      var sublist1 = response.body;
                      for(var v in sublist1){
                        this.idArr.push(sublist1[v].id);
                      }
                      this.firstIdArr = this.idArr;
                    }
                  )
                }
                
              }
              this.subnameOptions = sublist.map(item => {
                if(item.issub == 0){
                  return {label: item.name, value: item.id};
                }else{
                  return {label: item.name, value: item.id, children:[]};
                }
                
              });
            },
            response => {
              console.log('failed');
            }
          )
        }else{
          return '';
        }
      }
    },
    hasValue(strKey,arrObj){  //用于表格里某一列是否显示的判断： 该键值里的值如果有值，isvalue = true，否则 isvalue = false
      var hasvalue = false;
      for(var v in arrObj){
        if((arrObj[v][strKey] != '') && (arrObj[v][strKey] != 'undefined') && (arrObj[v][strKey] != null)){
          hasvalue = true;
        }else{
          hasvalue = false;
        }
      }
      return hasvalue;
    },
    clearSelect () {  //一级奖项clear的方法
      this.awardId = '';
      this.awardSubId = '';
      this.awardsSubNames = '';
      this.idArr = [];
      this.subnameOptions = [];
      this.subnameOptions.length = 0;
    },
    handleItemChange(val) {    // active-item-change事件使用，用于change-on-select的值为false  
      this.awardsSubNames = '';
        console.log('active item:', val);//生成练级奖项菜单
        if(val != 0){
          this.$http.get('api/search/get_awards_sublist', {params: {preId: val}}).then(
            response => {
              var k = getOptionsKey(val, this.subnameOptions);
              var sublist = response.body;
                this.subnameOptions[k].children = sublist.map(item => {
                  if(item.issub == 0){
                    return {label: item.name, value: item.id};
                  }else{
                    return {label: item.name, value: item.id, children:[]};
                  } 
                });
            },
            response => {
              console.log('failed');
            }
          )
        }else{
          console.log('xx');
        }
    },
    getaaa (val){
      this.tableData = [];
      console.log('active item:', val);//生成练级奖项菜单
      var k = getOptionsKey(val[val.length-1], this.subnameOptions);
      var thisSubOption = this.subnameOptions[k];
      this.$http.get('api/search/get_awards_sublist',{params: {preId: val[val.length-1]}}).then(
        response =>{
          var sublist = response.body;
          var tmparr = [];
          sublist.forEach(function(element){
            var tmpopt = {label:element.name, value:element.id,children:null};
            tmparr.push(tmpopt);
            thisSubOption.children = tmparr;
            if(element.issub){
               _mapOptions(element.id, thisSubOption, this);
            }
          },this);
        },
        response => {
          console.log('failed');
        }
      )

      this.idArr = val;
      getAwardsName(val, this);
      if(val.length == 0){
        this.idArr = this.firstIdArr;
        this.awardSubId = this.awardId;
      }else{
        this.awardSubId = val[val.length - 1];
      }
    },
    getThisAwardsId(val){
      this.tableData = [];
      console.log('active item:', val);//生成练级奖项菜单
      if(val != 0){
        this.$http.get('api/search/get_awards_sublist', {params: {preId: val}}).then(
          response => {
            var k = getOptionsKey(val, this.subnameOptions);
            var sublist = response.body;
            if(sublist.length == 0) return;
              this.subnameOptions[k].children = sublist.map(item => {
                if(item.issub == 0){
                  return {label: item.name, value: item.id};
                }else{
                  return {label: item.name, value: item.id, children:[]};
                } 
              });
          },
          response => {
            console.log('failed');
          }
        )
      }    
      this.idArr = val;
      getAwardsName(val, this);
      if(val.length == 0){
        this.idArr = this.firstIdArr;
        this.awardSubId = this.awardId;
      }else{
        this.awardSubId = val[val.length - 1];
      }
    },
    getTopAwardsName(id, obj){  //获取当前一级奖项名称
      var name = '';
      for(var i = 0; i < obj.length; i++){
        if(obj[i].value == id){
          name = obj[i].label;
        }
      }
      return name;
    },
    onSubmit () {
      if(this.year != ''){
        var year = new Date(this.year);
        this.formInline.year = year.getFullYear();
      }else{
        this.formInline.year = this.year;
      }
      this.$router.push({path: 'result', query: this.formInline});
      var that = this;
      getData(that, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },
    handleCurrentChange(val) { //当前在第几页
      this.currentPage = val;
      this.$router.push({path: 'result', query: this.formInline});
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },
    handleSizeChange(val) {  //每页显示多少条
      this.countPerPage = val;
      this.$router.push({path: 'result', query: this.formInline});
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },
    onSearch(){
      console.log(this.qname);
      this.formInline.qname = this.qname;
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);
      this.qname = '';
    },
    gotoList(awardId,aname){
      this.qname = this.formInline.qname;
      this.formInline.qname = '';
      this.awardSubId = awardId;
      this.awardsSubNames = aname;
      this.$http.get('api/search/awards_company_list', {params: {where:{awardId: awardId},countPerPage: this.countPerPage, 
              currentPage: this.currentPage,}}).then(
          response => {
            this.tableData = response.body;
            this.total = response.body.length;
            console.log(this.total);
          },
          response => {
            console.log('failed');
          }
        )
    },
    setHeight (){
      var height = window.innerHeight - 370;
      $('.result-list-out').css('min-height', height + 'px');
      var width = window.innerWidth;
      if(width < 1023){
        this.isInline = false;
        $('.join-us').css('bottom', '10px');
      }else{
        $('.join-us').css('bottom', '170px');
      }
    }
  
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Result.vue